import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api';
import { getKgChecklistTemplates, getWpColumnDefs } from '@/features/work-packages/api';

export const wpColumnDefsQuery = (tenderId: string) =>
  queryOptions({
    queryKey: ['wpColumnDefs', tenderId],
    queryFn: () => getWpColumnDefs(tenderId),
  });

export const kgChecklistTemplatesQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['kgWpChecklistTemplates', organizationId],
    queryFn: () => getKgChecklistTemplates(organizationId),
  });

export const scopePackageChoicesQuery = (tenderId: string) =>
  queryOptions({
    queryKey: ['scopePackageChoices', tenderId],
    queryFn: () =>
      api
        .get<{
          packages: {
            id: string;
            displayName: string;
            kind: 'normal' | 'rest';
            itemIds: string[];
          }[];
        }>('v1/work-packages/scope-breakdown/packages', { params: { tenderId } })
        .then(({ data }) => data),
  });
